import { useState } from "react";
import { toast } from "react-toastify";

import { TContractType } from "../utils/contractType";
import { ToastProps } from "react-toastify/dist/types";
import NegotiationMassive from "../api/negotiationMassive";

export const useUploadFile = (id: number, contractType: TContractType, lang: 'las' | 'br') => {
    const [responseOk, setResponseOk] = useState<boolean>(false);
    const toastConfig: Partial<ToastProps> = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    };
    
    const handleUploadFile = () => {
        setResponseOk(false);
        const uploadAncher = document.createElement('input');
        uploadAncher.style.display = 'none';
        uploadAncher.type = "file";
        uploadAncher.click();
        
        uploadAncher.addEventListener("change", (event: any) => {
            if (uploadAncher && uploadAncher.files && uploadAncher.files.length > 0) {
                const fileSize = uploadAncher.files.item(0)?.size ?? 0;
                const fileMb = fileSize / 1024 ** 2;
                if (fileMb >= 2) {
                    toast(lang === "br" ? "Arquivo deve conter no máximo 2MB" : "El archivo debe tener un tamaño máximo de 2MB", {
                        ...toastConfig,
                        type: "error"
                    });
                } else {
                    execUploadFile(event?.target?.files[0])                                       
                }
            }
        })
    }

    const execUploadFile = (file: any) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", file?.name);
        const config = {
            headers: {
              'content-type': 'multipart/form-data',
            },
        };
        NegotiationMassive.importContracts(contractType, id, formData, config)
        .then(() => {
            toast(lang === "br" ? "Arquivo enviado com sucesso" : "Archivo enviado con éxito", {
                ...toastConfig,
                type: "success"
            });
            setResponseOk(true);
        }).catch((err) => {
            console.log(err);
            setResponseOk(false);
            if (err?.response?.status === 404) {
                toast(lang === "br" ? "Erro ao importar o arquivo! Revise as informações preenchidas e/ou solicite suporte por e-mail" : "¡Error al importar el archivo! Verifique la información ingresada y/o solicite asistencia por correo electrónico", {
                    ...toastConfig,
                    type: "error"
                });
            } else {
                toast(lang === "br" ? "Erro ao importar o arquivo!" : "¡Error al importar el archivo!", {
                    ...toastConfig,
                    type: "error"
                });
            }
        })
    }

    return {
        handleUploadFile,
        responseOk
    }
}